import { useContext } from "react";
import { BrandingContext } from "@shared/features/common/Branding.context";

export const useBranding = () => useContext(BrandingContext)!;
